"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DomainSearchBoxLoader = exports.DomainSearchBox = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _DomainSearchBox = require("./styles/DomainSearchBox.js");
var _classnames = _interopRequireDefault(require("classnames"));
var _EidCodes = _interopRequireDefault(require("./EidCodes"));
var _utils = require("@site/utils");
var _uxUtils = require("@site/ux-utils");
var _reactMintl = require("@godaddy/react-mintl");
var _search = _interopRequireDefault(require("@site/search"));
var _config = _interopRequireDefault(require("./config.js"));
var _hooks = _interopRequireDefault(require("./hooks.js"));
var _SearchFlyoutContent = require("./components/SearchFlyoutContent");
var _sharedComponents = require("@site/shared-components");
var _SearchButtons = _interopRequireDefault(require("./components/SearchButtons.js"));
var _PromptModal = require("./components/PromptRecommendations/PromptModal");
var _useFetchPrompts = require("./hooks/useFetchPrompts");
var _usePromptRecommendations = require("./hooks/usePromptRecommendations");
var _constants = require("./constants.js");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable react/no-children-prop */
/* eslint-disable complexity */
/* eslint-disable id-length */

const DomainSearchBox = props => {
  const {
    language = {}
  } = {
    ...props
  };
  const {
    apm,
    overrideProps,
    languageStrings
  } = (0, _sharedComponents.useComponentDataProvider)(language);
  const {
    voiceSearchProps = {
      useVoiceSearch: false,
      voiceButtonStyling: {},
      voiceButtonText: '',
      voiceTooltipText: ''
    },
    autocompleteMode = '',
    env = 'dev',
    apiKey,
    eidPrefix = _EidCodes.default.EidBase,
    market: marketOverride,
    onChange = () => {},
    onError = () => {},
    onSearch = () => {},
    logger = () => {},
    plid = 1,
    query = '',
    domainNamesFetchCallback,
    forceHideSuggest,
    debounceDelay,
    dataPartial,
    styling = {},
    id = 'input-search-box',
    placeholder,
    hintsConfig,
    overlayEnabled,
    apiVersion,
    ariaLabels = {
      searchLabel: 'Domain search box',
      searchButton: 'Domain search button'
    },
    maxResults = _config.default.MAX_AUTO_COMPLETE_LENGTH,
    icon,
    hideIcon = false,
    buttonText,
    resellerBaseOverride,
    customSearchSuggestions = {
      iconsAndDomainsArray: [],
      maxDropDownSuggestions: 5,
      contentForDropdownBox: null,
      showSearchComparisonCards: false,
      searchComparisonCardsData: null,
      enableCustomAutoComplete: false
    },
    disableSearch = false,
    appName,
    promptRecommendationOptions = {
      showPrompts: false,
      selection: null,
      promptConfig: null
    },
    ...searchProps
  } = {
    ...props,
    ...overrideProps
  };
  const [showAutoComplete, setShowAutoComplete] = (0, _react.useState)(false);
  const [showCustomAutoComplete, setShowCustomAutoComplete] = (0, _react.useState)(false);
  const [isHintsVisible, setIsHintsVisible] = (0, _react.useState)(false);
  const [showCustomSuggestions, setShowCustomSuggestions] = (0, _react.useState)(false);
  const [isSearchFocused, setIsSearchFocused] = (0, _react.useState)(false);
  const searchInput = (0, _react.useRef)(null);
  const {
    iconsAndDomainsArray,
    maxDropDownSuggestions,
    contentForDropdownBox,
    enableCustomAutoComplete = false,
    searchComparisonCardsData = _config.default.DEFAULT_SEARCH_COMPARISON_CARDS,
    showSearchComparisonCards = false
  } = customSearchSuggestions;
  const market = marketOverride || (0, _utils.getCookie)('market') || 'en-US';
  const focusEid = eidPrefix + _EidCodes.default.ClickSearchBox;
  const suggestEid = eidPrefix + _EidCodes.default.SuggestedDomainsDropDown;
  const searchHxDropdownEid = eidPrefix + _EidCodes.default.SearchHistoryDropdown;
  const queryEids = {
    searchEid: eidPrefix + _EidCodes.default.SearchButton,
    voiceToTextEid: eidPrefix + _EidCodes.default.VoiceSearch,
    voiceToTextErrorEid: eidPrefix + _EidCodes.default.VoiceSearchError,
    SpeechRecognitionApiError: eidPrefix + _EidCodes.default.SpeechRecognitionApiError
  };
  const autoCompleteData = (0, _hooks.default)({
    autocompleteMode,
    env,
    apiKey,
    market,
    onError,
    plid,
    query,
    domainNamesFetchCallback,
    debounceDelay,
    apiVersion,
    resellerBaseOverride,
    apm
  });
  const serviceParams = {
    apiKey,
    market,
    plid,
    env,
    appName,
    apm,
    eidPrefix
  };
  const [promptsData, promptStatus] = (0, _useFetchPrompts.useFetchPrompts)(serviceParams, promptRecommendationOptions);
  const promptRecommendationsResult = (0, _usePromptRecommendations.usePromptRecommendations)(serviceParams, searchInput);
  const {
    showPrompts
  } = promptRecommendationOptions || {};
  const updateAutoCompleteState = value => {
    enableCustomAutoComplete ? setShowCustomAutoComplete(value) : setShowAutoComplete(value);
  };
  const hasIconsAndDomains = showSearchComparisonCards ? iconsAndDomainsArray?.length >= 0 : iconsAndDomainsArray?.length > 0;
  const hasAutoCompleteData = showSearchComparisonCards ? autoCompleteData?.length >= 0 : autoCompleteData?.length > 0;
  const isCustomSuggestionsEnabled = hasIconsAndDomains && maxDropDownSuggestions > 0 && !query || enableCustomAutoComplete && query && hasAutoCompleteData;

  // Only show prompt recommendations if eligible and search box has focus and shopper isn't typing in search box yet
  const isPromptRecommendationsAllowed = showPrompts && [_constants.REQUEST_STATUS.SUCCESS, _constants.REQUEST_STATUS.LOADING].includes(promptStatus) && !query;
  const showPromptRecommendationsFlyout = isPromptRecommendationsAllowed && isSearchFocused;
  const isDropDownOpen = isCustomSuggestionsEnabled && showCustomSuggestions || showAutoComplete && !forceHideSuggest && hasAutoCompleteData || showPromptRecommendationsFlyout;
  const isHintsEnabled = Boolean(hintsConfig);
  const prevIsHintsEnabled = (0, _uxUtils.usePrevious)(isHintsEnabled);
  const {
    runHints,
    hideHints
  } = (0, _uxUtils.usePlaceholderHints)({
    hintsConfig,
    id
  });
  const onSearchHandler = value => {
    onSearch(value);
    updateAutoCompleteState(false);
    setShowCustomSuggestions(false);
    setIsSearchFocused(false);
  };
  const onConfirmCustomSuggestHandler = (value, position) => {
    const onSelectData = {
      domainName: value,
      suggestionType: 'customSuggestionList',
      dropDownPosition: position,
      url: window.location.href
    };
    (0, _utils.logEvent)({
      eid: searchHxDropdownEid,
      type: 'click',
      properties: onSelectData
    });
    onSearchHandler(value);
  };
  const onConfirmHandler = (value, extraInfo) => {
    const isDropDownEvent = !!extraInfo.event;
    if (isDropDownEvent) {
      const index = autoCompleteData.indexOf(value) + 1;
      const onSelectData = {
        domainName: value,
        suggestionType: autocompleteMode,
        dropDownPosition: index,
        url: window.location.href
      };
      (0, _utils.logEvent)({
        eid: suggestEid,
        type: 'click',
        properties: onSelectData
      });
      extraInfo.event.target?.blur();
      showCustomSuggestions && setShowCustomSuggestions(false);
    } else {
      (0, _utils.logEvent)({
        eid: queryEids.searchEid,
        type: 'click'
      });
      extraInfo.target?.blur();
    }
    onSearchHandler(value);
  };
  const onFocusHandler = event => {
    setIsHintsVisible(false);
    updateAutoCompleteState(true);
    setIsSearchFocused(true);
    const value = event?.target.value;
    if (typeof value === 'string' && document.activeElement.id === id) {
      const onFocusData = {
        domainName: value,
        suggestionType: autocompleteMode,
        url: global.window.location.href,
        isPromptRecommendations: isPromptRecommendationsAllowed
      };
      (0, _utils.logEvent)({
        eid: focusEid,
        type: 'click',
        properties: onFocusData
      });
    }
    if (isCustomSuggestionsEnabled) {
      setShowCustomSuggestions(true);
    }
  };
  const onCloseDropdown = () => {
    if (showCustomSuggestions) setShowCustomSuggestions(false);
    updateAutoCompleteState(false);
    if (isSearchFocused) setIsSearchFocused(false);
  };
  const getCustomSuggestions = () => {
    if (enableCustomAutoComplete && query && showCustomAutoComplete) {
      return [{
        domainNames: autoCompleteData
      }];
    }
    if (isCustomSuggestionsEnabled && !query) {
      return iconsAndDomainsArray;
    }
    return [];
  };
  (0, _react.useEffect)(() => {
    if (showSearchComparisonCards && searchInput.current && showCustomSuggestions) {
      searchInput.current.focus();
    }
  }, [showCustomSuggestions, showSearchComparisonCards]);
  (0, _react.useEffect)(() => {
    setIsHintsVisible(isHintsEnabled);
  }, [isHintsEnabled]);
  (0, _react.useEffect)(() => {
    if (isHintsEnabled) {
      if (isHintsVisible && !query) {
        runHints();
      } else {
        hideHints(query || !isHintsEnabled ? placeholder : '');
      }
    } else if (prevIsHintsEnabled) {
      hideHints(placeholder);
    }
  }, [isHintsEnabled, isHintsVisible, query]);
  (0, _react.useEffect)(() => {
    if (!query && document.activeElement === searchInput.current || showCustomAutoComplete && query) {
      setShowCustomSuggestions(true);
    }
  }, [query]);
  (0, _react.useEffect)(() => {
    if (enableCustomAutoComplete && !showCustomAutoComplete && query) {
      setShowCustomAutoComplete(true);
    }
  }, [query]);
  const searchBoxClassNames = (0, _classnames.default)('search-button', searchProps.className, {
    'background-color-customized': styling?.backgroundColor,
    'border-customized': styling?.border,
    'border-radius-customized': styling?.borderRadius,
    'button-color-customized': styling?.buttonColor,
    'button-border-customized': styling?.buttonBorder,
    'button-radius-customized': styling?.buttonRadius,
    'search-height-customized': styling?.height,
    'search-max-zindex': overlayEnabled && isDropDownOpen,
    'font-size-customized': styling?.fontSize,
    'hide-inner-borders': styling?.hideInnerBorders,
    'button-margin-customized': styling?.buttonMargin
  });
  const searchButtons = /*#__PURE__*/_react.default.createElement(_SearchButtons.default, {
    disableSearch: disableSearch,
    voiceSearchProps: voiceSearchProps,
    styling: styling,
    buttonDivClassname: searchBoxClassNames,
    icon: icon,
    hideIcon: hideIcon,
    buttonText: buttonText,
    ariaLabels: ariaLabels,
    setShowCustomSuggestions: setShowCustomSuggestions,
    updateAutoCompleteState: updateAutoCompleteState,
    logEvent: _utils.logEvent,
    onSearch: onSearch,
    query: query,
    overlayEnabled: overlayEnabled,
    isDropDownOpen: isDropDownOpen,
    buttonEids: queryEids,
    market: market
  });
  return /*#__PURE__*/_react.default.createElement(_reactMintl.IntlProvider, {
    locale: market,
    key: market,
    messages: languageStrings ?? {}
  }, /*#__PURE__*/_react.default.createElement(_DomainSearchBox.StyledSearchWrapper, {
    "data-partial": dataPartial,
    styling: styling,
    voiceButtonStyling: voiceSearchProps?.voiceButtonStyling,
    "data-cy": "domain-search-box"
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "search-bg-overlay",
    className: (0, _classnames.default)({
      'search-bg-overlay': overlayEnabled && isDropDownOpen
    })
  }), /*#__PURE__*/_react.default.createElement("form", {
    action: "."
  }, /*#__PURE__*/_react.default.createElement(_search.default, (0, _extends2.default)({}, searchProps, {
    "data-testid": "domain-search-box-input",
    type: "search",
    id: id,
    ref: searchInput,
    "aria-label": ariaLabels.searchLabel,
    disabled: disableSearch,
    button: searchButtons,
    placeholder: placeholder,
    className: searchBoxClassNames,
    open: isDropDownOpen,
    items: (!enableCustomAutoComplete && autoCompleteData || []).slice(0, maxResults),
    onFocus: onFocusHandler,
    onBlur: () => {
      setIsHintsVisible(true);
    }
    // the callback when typing in text input area
    ,
    onChange: onChange
    // handle search when pressing Enter or mouse click
    ,
    onConfirm: onConfirmHandler,
    onClose: onCloseDropdown,
    value: query,
    children: /*#__PURE__*/_react.default.createElement(_SearchFlyoutContent.SearchFlyoutContent, {
      onConfirmCustomSuggestHandler: onConfirmCustomSuggestHandler,
      showCustomSuggestions: showCustomSuggestions,
      showPromptRecommendations: showPromptRecommendationsFlyout,
      promptRecommendationsData: {
        promptsData,
        promptStatus,
        options: promptRecommendationOptions
      },
      maxDropDownSuggestions: maxDropDownSuggestions,
      logger: logger,
      showSearchComparisonCards: showSearchComparisonCards,
      searchComparisonCardsData: searchComparisonCardsData,
      contentForDropdownBox: contentForDropdownBox,
      suggestionsToDisplay: getCustomSuggestions(),
      styling: styling,
      eidPrefix: eidPrefix,
      promptResult: promptRecommendationsResult
    })
  })))), showPrompts && /*#__PURE__*/_react.default.createElement(_PromptModal.PromptModal, {
    data: promptRecommendationsResult,
    params: serviceParams
  }));
};
exports.DomainSearchBox = DomainSearchBox;
DomainSearchBox.propTypes = {
  appName: _propTypes.default.string,
  language: _propTypes.default.object,
  ariaLabels: _propTypes.default.shape({
    searchLabel: _propTypes.default.string,
    searchButton: _propTypes.default.string
  }),
  autocompleteMode: _propTypes.default.oneOf(['domain', 'query', '']),
  buttonText: _propTypes.default.string,
  env: _propTypes.default.oneOf(['dev', 'test', 'prod']),
  icon: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.elementType]),
  hideIcon: _propTypes.default.bool,
  market: _propTypes.default.string,
  maxResults: _propTypes.default.number,
  eidPrefix: _propTypes.default.string,
  onChange: _propTypes.default.func,
  onError: _propTypes.default.func,
  onSearch: _propTypes.default.func,
  logger: _propTypes.default.func,
  plid: _propTypes.default.number,
  query: _propTypes.default.string,
  domainNamesFetchCallback: _propTypes.default.func,
  forceHideSuggest: _propTypes.default.bool,
  debounceDelay: _propTypes.default.number,
  dataPartial: _propTypes.default.string,
  styling: _propTypes.default.shape({
    backgroundColor: _propTypes.default.string,
    border: _propTypes.default.string,
    borderRadius: _propTypes.default.string,
    buttonRadius: _propTypes.default.string,
    buttonColor: _propTypes.default.string,
    buttonColorHover: _propTypes.default.string,
    buttonIconColor: _propTypes.default.string,
    buttonBorder: _propTypes.default.string,
    height: _propTypes.default.string,
    fontSize: _propTypes.default.string,
    hideInnerBorders: _propTypes.default.bool,
    buttonMargin: _propTypes.default.string
  }),
  id: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  searchProps: _propTypes.default.shape({
    className: _propTypes.default.string,
    clearable: _propTypes.default.bool,
    autoCorrect: _propTypes.default.string,
    autoCapitalize: _propTypes.default.string,
    spellCheck: _propTypes.default.bool
  }),
  hintsConfig: _propTypes.default.shape({
    phrases: _propTypes.default.arrayOf(_propTypes.default.string),
    beforeDeleteDelay: _propTypes.default.number,
    beforeWriteDelay: _propTypes.default.number,
    deleteDelay: _propTypes.default.number,
    writeDelay: _propTypes.default.number
  }),
  overlayEnabled: _propTypes.default.bool,
  apiVersion: _propTypes.default.string,
  resellerBaseOverride: _propTypes.default.string,
  apiKey: _propTypes.default.string.isRequired,
  forceEnableBFF: _propTypes.default.bool,
  customSearchSuggestions: _propTypes.default.shape({
    iconsAndDomainsArray: _propTypes.default.arrayOf(_propTypes.default.shape({
      icon: _propTypes.default.func,
      domainNames: _propTypes.default.arrayOf(_propTypes.default.string)
    })),
    contentForDropdownBox: _propTypes.default.func,
    maxDropDownSuggestions: _propTypes.default.number,
    enableCustomAutoComplete: _propTypes.default.bool,
    showSearchComparisonCards: _propTypes.default.bool,
    searchComparisonCardsData: _propTypes.default.shape({
      variant: _propTypes.default.string,
      cardConfigs: _propTypes.default.arrayOf(_propTypes.default.shape({
        type: _propTypes.default.string,
        title: _propTypes.default.string,
        description: _propTypes.default.string,
        icon: _propTypes.default.string,
        iconColor: _propTypes.default.string,
        mediaType: _propTypes.default.string,
        customAnimation: _propTypes.default.shape({
          text: _propTypes.default.string,
          tldList: _propTypes.default.arrayOf(_propTypes.default.string),
          delay: _propTypes.default.number,
          loopDelay: _propTypes.default.number
        })
      }))
    })
  }),
  disableSearch: _propTypes.default.bool,
  voiceSearchProps: _propTypes.default.shape({
    useVoiceSearch: _propTypes.default.bool,
    voiceButtonText: _propTypes.default.string,
    voiceTooltipText: _propTypes.default.string,
    voiceButtonStyling: _propTypes.default.shape({
      buttonColor: _propTypes.default.string,
      buttonIconColor: _propTypes.default.string,
      buttonBorder: _propTypes.default.string,
      buttonDesign: _propTypes.default.string,
      buttonColorHover: _propTypes.default.string
    })
  }),
  promptRecommendationOptions: _propTypes.default.shape({
    selection: _propTypes.default.string,
    showPrompts: _propTypes.default.bool,
    promptConfig: _propTypes.default.shape({
      title: _propTypes.default.string,
      description: _propTypes.default.string,
      ventureText: _propTypes.default.string,
      portfolioText: _propTypes.default.string,
      ccTldText: _propTypes.default.string,
      compactText: _propTypes.default.string
    })
  })
};
const DomainSearchBoxLoader = ({
  styling
}) => {
  return /*#__PURE__*/_react.default.createElement(_DomainSearchBox.StyledSearchWrapper, {
    styling: styling
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "domain-search-box-loader"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('d-flex justify-content-between', {
      'border-customized': styling?.border,
      'border-radius-customized': styling?.borderRadius
    })
  }, /*#__PURE__*/_react.default.createElement(_sharedComponents.SkeletonLoader, {
    className: "mx-2 my-2",
    height: "1rem",
    width: "75%"
  }), /*#__PURE__*/_react.default.createElement(_sharedComponents.SkeletonLoader, {
    className: "mx-2 my-2",
    height: "1rem",
    width: "3%"
  }))));
};
exports.DomainSearchBoxLoader = DomainSearchBoxLoader;
DomainSearchBoxLoader.propTypes = {
  styling: _propTypes.default.object
};
const DomainSearchBoxWithComponentDataProvider = props => {
  const style = {
    border: '1px solid lightgrey',
    borderRadius: '7px'
  };
  return /*#__PURE__*/_react.default.createElement(_sharedComponents.ComponentDataProvider, {
    appName: props.appName,
    componentName: "domain-search-box",
    apiKey: props.apiKey,
    forceEnableBFF: props.forceEnableBFF,
    loader: /*#__PURE__*/_react.default.createElement(DomainSearchBoxLoader, {
      styling: props.styling || style
    })
  }, /*#__PURE__*/_react.default.createElement(DomainSearchBox, props));
};
DomainSearchBoxWithComponentDataProvider.propTypes = DomainSearchBox.propTypes;
var _default = exports.default = DomainSearchBoxWithComponentDataProvider;